// src/store/features/billers/billerSaga.ts
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchBillersRequest,
  fetchBillersSuccess,
  fetchBillersFailure,
  getBillerByCategoryRequest,
} from "./billerActions";
import billerService from "../../../services/api.services/biller/billerService";

function* fetchBillersSaga(
  action: ReturnType<typeof fetchBillersRequest>, // | ReturnType<typeof getBillerByCategoryRequest>,
): any {
  try {
    // console.log("fetchBillersSaga", action.payload);

    const response = yield call(billerService.fetchBillersApi, action.payload);
    // const responses = yield call(billerService.getBillerByCategory, action.payload);

    yield put(fetchBillersSuccess(response.data));
  } catch (error: any) {
    yield put(fetchBillersFailure(error.message));
  }
}

function* getBillerByCategorySaga(
  action: ReturnType<typeof getBillerByCategoryRequest>,
): any {
  try {
    const { category } = action.payload;

    const response = yield call(billerService.getBillerByCategory, category);
    yield put(fetchBillersSuccess(response.data));
  } catch (error: any) {
    yield put(fetchBillersFailure(error.message));
  }
}

export default function* billerSaga() {
  yield all([
    takeLatest(fetchBillersRequest.type, fetchBillersSaga),
    takeLatest(getBillerByCategoryRequest.type, getBillerByCategorySaga),
  ]);
}
